var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.5V15.5C13.5 16.0523 13.0523 16.5 12.5 16.5H4.5C3.94772 16.5 3.5 16.0523 3.5 15.5V12.5M13.5 12.5V9.5H3.5V12.5M13.5 12.5H14.5C15.6046 12.5 16.5 11.6046 16.5 10.5V6.5C16.5 5.39543 15.6046 4.5 14.5 4.5H2.5C1.39543 4.5 0.5 5.39543 0.5 6.5V10.5C0.5 11.6046 1.39543 12.5 2.5 12.5H3.5M13 6.5H14.5M5.5 12H11.5M5.5 14H11.5M13.5 4.5V2.5C13.5 1.39543 12.6046 0.5 11.5 0.5H5.5C4.39543 0.5 3.5 1.39543 3.5 2.5V4.5H13.5Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.1fc0ec37f68d4d58198b5bbb75ebe8cd.svg";
export { ForwardRef as ReactComponent };